import CustomLogo from './CustomLogo';

export const Icons = {
  Plus: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 5v14m7-7H5" />
    </svg>
  ),

  Copy: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} 
            d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
    </svg>
  ),

  Download: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
    </svg>
  ),

  FileSpreadsheet: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 17h6l3 3v-3h2V4H4v13h2v3l3-3z" />
    </svg>
  ),

  Swap: ({ className }) => (
    <svg className={className} viewBox="0 0 24 24" fill="none" stroke="currentColor">
      <polyline strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                points="17,1 21,5 17,9" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M21,5 L3,5" />
      <polyline strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                points="7,23 3,19 7,15" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
            d="M21,19 L3,19" />
    </svg>
  ),

  Trash2: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 6h18m-2 0v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2" />
    </svg>
  ),

  Edit3: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  ),

  Save: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" />
    </svg>
  ),

  X: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
    </svg>
  ),

  Eye: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
    </svg>
  ),

  Upload: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12" />
    </svg>
  ),

  Wire: ({ className = '' }) => (
    <svg className={className} width={24} height={24} viewBox="0 0 512 512" fill="none">
      <g>
        <path d="M220.885,106.105c-5.078,0-9.578-3.641-10.492-8.82l-11.109-63.021c-1.023-5.805,2.852-11.335,8.648-12.359c5.805-1.023,11.335,2.852,12.359,8.656l11.108,63.021c1.023,5.805-2.851,11.335-8.647,12.359C222.127,106.05,221.502,106.105,220.885,106.105z" fill="#434A54" />
        <path d="M291.101,106.105c-0.609,0-1.234-0.055-1.859-0.164c-5.812-1.023-9.687-6.554-8.656-12.359l11.109-63.021c1.016-5.804,6.546-9.679,12.358-8.656c5.797,1.023,9.671,6.554,8.656,12.359l-11.125,63.021C300.679,102.464,296.179,106.105,291.101,106.105z" fill="#434A54" />
        <path d="M255.992,85.324c-5.891,0-10.664-4.773-10.664-10.664V10.663C245.328,4.772,250.101,0,255.992,0c5.891,0,10.665,4.772,10.665,10.663V74.66C266.657,80.551,261.884,85.324,255.992,85.324z" fill="#434A54" />
        <path d="M277.337,63.997h-42.68c-5.89,0-10.663,4.773-10.663,10.664v234.656c0,5.89,4.773,10.671,10.663,10.671h42.68c5.874,0,10.655-4.781,10.655-10.671V74.66C287.992,68.77,283.211,63.997,277.337,63.997z" fill="#A0D468" />
      </g>
    </svg>
  ),

  DragHandle: ({ className }) => (
    <svg className={className} fill="currentColor" viewBox="0 0 20 20">
      <path d="M7 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM7 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM17 2a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM17 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0zM17 14a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
    </svg>
  ),

  Cable: ({ className = '', style }) => (
    <svg className={className} style={style} width={24} height={24} viewBox="0 0 512 512" fill="currentColor">
      <g>
        <path d="M220.885,106.105c-5.078,0-9.578-3.641-10.492-8.82l-11.109-63.021c-1.023-5.805,2.852-11.335,8.648-12.359c5.805-1.023,11.335,2.852,12.359,8.656l11.108,63.021c1.023,5.805-2.851,11.335-8.647,12.359C222.127,106.05,221.502,106.105,220.885,106.105z" />
        <path d="M291.101,106.105c-0.609,0-1.234-0.055-1.859-0.164c-5.812-1.023-9.687-6.554-8.656-12.359l11.109-63.021c1.016-5.804,6.546-9.679,12.358-8.656c5.797,1.023,9.671,6.554,8.656,12.359l-11.125,63.021C300.679,102.464,296.179,106.105,291.101,106.105z" />
        <path d="M255.992,85.324c-5.891,0-10.664-4.773-10.664-10.664V10.663C245.328,4.772,250.101,0,255.992,0c5.891,0,10.665,4.772,10.665,10.663V74.66C266.657,80.551,261.884,85.324,255.992,85.324z" />
        <path d="M277.337,63.997h-42.68c-5.89,0-10.663,4.773-10.663,10.664v234.656c0,5.89,4.773,10.671,10.663,10.671h42.68c5.874,0,10.655-4.781,10.655-10.671V74.66C287.992,68.77,283.211,63.997,277.337,63.997z" />
      </g>
    </svg>
  ),

  ChevronDown: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
    </svg>
  ),
  CustomLogo: CustomLogo,

  Settings: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
    </svg>
  ),

  User: ({ className }) => (
    <svg className={className} fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
    </svg>
  )
};

export default Icons;